import access from '@/assets/mellow-illustrations/access.webp';
import activity from '@/assets/mellow-illustrations/activity.webp';
import applications from '@/assets/mellow-illustrations/applications.webp';
import connections from '@/assets/mellow-illustrations/connections.webp';
import people from '@/assets/mellow-illustrations/people.webp';
import signIn from '@/assets/mellow-illustrations/sign-in.webp';

const artwork = { access, activity, applications, connections, people, 'sign-in': signIn };

type Props = {
  readonly scene: keyof typeof artwork;
  readonly className?: string;
};

export default function MellowIllustration({ scene, className }: Props) {
  return (
    <img
      alt=""
      width={200}
      height={200}
      className={className}
      src={artwork[scene]}
      style={{ objectFit: 'contain', maxWidth: '100%' }}
    />
  );
}
